module.exports = __webpack_public_path__ + "img/image_offline07@2x.d5e591ef.png";